import { Loading, useShowQuery } from "@dgs/core";
import { FC } from "react";
import { Navigate, useParams } from "react-router";
import { companyService } from "../shared/api/companyService";

export const RedirectToCompany: FC = () => {
	const { id = "" } = useParams();
	const { data: company } = useShowQuery(id, companyService);

	if (!company) {
		return <Loading />;
	}

	if (company.isArchived) {
		return <Navigate to={`/companies/archived/${company.id}`} replace={true} />;
	} else {
		return <Navigate to={`/companies/active/${company.id}`} replace={true} />;
	}
};
